import { IonCard } from '@ionic/react'
import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ModalContext } from '../../../contexts/ModalContext'
import useTrackers from '../charts/consumptionChart/hooks/useTrackers'
import Button from '../../../components/actions/Button'

const TrackerCard = () => {
	const { insertModal } = useContext(ModalContext)
	const { t } = useTranslation('pages_electricity')
	const { data } = useTrackers()
	const [limitsOn, setLimitsOn] = useState(0)

	useEffect(() => {
		setLimitsOn(data?.filter((e: any) => e.enabled).length ?? 0)
	}, [data])

	const handleClick = () => insertModal('trackerModal')

	return (
		<IonCard id='tracker-card' className='bg-white dark:bg-[#0d2d30] shadow-card'>
			<div className='left'>
				<span className='text-text-dark dark:text-white'>{t('trackerCard.hintavahti')}</span>
				<span className=''>
					<span
						className={
							limitsOn
								? 'text-brand-secondary-100-light dark:text-brand-secondary-100-dark'
								: 'text-text-grey-200 dark:text-text-grey-100'
						}
					>
						{limitsOn > 0
							? `${limitsOn} ${limitsOn === 1 ? t('trackerCard.vahtiPaalla') : t('trackerCard.vahtiaPaalla')}`
							: t('trackerCard.eiPaalla')}
					</span>
				</span>
			</div>
			<div className='right'>
				<Button onClick={handleClick}>{t('muokkaa', { ns: 'common' })}</Button>
			</div>
		</IonCard>
	)
}

export default TrackerCard
